import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { PatternlibSlider } from "@liebherr/patternlib-react";
import styles from "./Slider.module.css";
import PropTypes from "prop-types";

const Slider = ({ label, data, variable, onChange }) => {
  const { t, i18n } = useTranslation();
  const sliderRef = useRef();
  const [value, setValue] = useState({});
  const [settings, setSettings] = useState({
    description: "Range description",
    max: "100",
    min: "0",
    valueMin: "0",
  });

  // Call function, when button clicked
  const updateValues = (value) => {
    if (value?.value !== undefined) {
      onChange(value);
    }
  };

  useEffect(() => {
    const ref = sliderRef.current;
    let valueData;
    const onChangeListener = (event) => {
      const val = Math.round(event.detail.value);
      const obj = { variable, value: val };
      setValue(obj);
      valueData = obj;
    };
    const onInputEndListener = () => {
      updateValues(valueData);
    };
    // attach the event to the component
    ref.addEventListener("lhChange", onChangeListener, false);
    ref.addEventListener("lhInputEnd", onInputEndListener, false);
    // remove event on component unmount
    return () => {
      ref.removeEventListener("lhChange", onChangeListener, true);
      ref.removeEventListener("lhInputEnd", onInputEndListener, true);
    };
  }, [sliderRef]);

  // Call function, when data has been changed and set settings for slider
  useEffect(() => {
    if (data !== undefined && data.values[0]["og"] && data.values[0]["ug"]) {
      setSettings({
        description: data["range_description"],
        max: data.values[0]["og"],
        min: data.values[0]["ug"],
        valueMin: data["resolvedVal"],
      });
    } else if (data !== undefined) {
      if (data["min"] !== undefined || data["max"] !== undefined) {
        setSettings({
          description:
            `${t("finder.range")}: ` +
            data["min"] +
            ` ${t("finder.rangeTo")} ` +
            data["max"],
          max: data["max"],
          min: data["min"],
          valueMin: data["resolvedVal"],
        });
      } else {
        setSettings({
          description:
            `${t("finder.range")}: ` +
            data.values[0]["value"] +
            ` ${t("finder.rangeTo")} ` +
            data.values[data.values.length - 1]["value"],
          max: data.values[data.values.length - 1]["value"],
          min: data.values[0]["value"],
          valueMin: data["resolvedVal"],
        });
      }
    }
  }, [data]);

  return (
    <div>
      <PatternlibSlider
        max={settings["max"]}
        min={settings["min"]}
        value-min={settings["valueMin"]}
        name={variable}
        ref={sliderRef}
        label={label}
        additional-info={settings["description"]}
      ></PatternlibSlider>
      <div className={styles.sliderWrapper}>
        <p>
          {value?.value !== undefined
            ? Math.round(value.value)
            : settings["valueMin"]}
        </p>
      </div>
    </div>
  );
};

Slider.propTypes = {
  label: PropTypes.string,
  data: PropTypes.any,
  variable: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

Slider.defaultProps = {
  label: "",
};

export default Slider;
